import React from "react";
import { Icon } from "../../UIElements/Icon";

const WidgetTypeCard = ({ widget, isSelected, onSelect }) => {
  return (
    <button
      onClick={onSelect}
      className={`relative h-full w-full rounded-xl border-2 p-5 text-left transition-all duration-200 ${
        isSelected
          ? "border-brand-cyan bg-brand-cyan/10 shadow-brand-cyan/20 shadow-lg"
          : "border-border hover:border-brand-cyan/50 hover:bg-accent"
      } `}
    >
      {widget.popular && (
        <span className="bg-brand-gradient absolute -top-2 -right-2 rounded-full px-2 py-0.5 text-xs font-medium text-white">
          Popular
        </span>
      )}

      <div
        className={`mb-4 flex h-12 w-12 items-center justify-center rounded-xl ${isSelected ? "bg-brand-gradient" : "bg-accent"} `}
      >
        <Icon
          name={widget.icon}
          className={`h-6 w-6 ${isSelected ? "text-white" : "text-muted-foreground"}`}
        />
      </div>

      <h3 className="text-card-foreground mb-2 font-semibold">{widget.name}</h3>
      <p className="text-muted-foreground mb-4 text-sm">{widget.description}</p>

      <div className="flex flex-wrap gap-2">
        {widget.features.map((feature, index) => (
          <span
            key={index}
            className="bg-accent text-muted-foreground rounded-md px-2 py-1 text-xs"
          >
            {feature}
          </span>
        ))}
      </div>

      {isSelected && (
        <div className="absolute top-4 right-4">
          <div className="bg-brand-gradient flex h-6 w-6 items-center justify-center rounded-full">
            <Icon name="Check" className="h-4 w-4 text-white" />
          </div>
        </div>
      )}
    </button>
  );
};

export default WidgetTypeCard;
